import React, { useEffect } from "react";
import { listBackupsForType } from "../../../redux/actions/backupRestoreActions";
import { useDispatch, useSelector } from "react-redux";
import RestoreFlow from "./RestoreFlow";
import BackupFlowButton from "../../../backupRestore/BackupFlowButton";
import { Box, Stack, xcss } from "@atlaskit/primitives";

const BackupPage = () => {
  const flow = useSelector((state) => state.integration.flow);
  //list of bucket keys in format customerid/flow/flowid/filename.json
  const dispatch = useDispatch();

  useEffect(() => {
    if (flow) {
      dispatch(listBackupsForType("flow", flow.id));
    }
  }, [flow]);
  const boxStyle = xcss({
    marginTop: "22px",
    border: "1px solid var(--ds-border,rgb(196, 194, 194));",
    borderRadius: "4px",
    padding: "16px",
    backgroundColor: "var(--ds-surface-raised,rgb(255, 255, 255));",
  });

  return (
    <>
      <h4>Backups & Restore</h4>
      <Stack space="space.500">
        <Box xcss={boxStyle}>
          <BackupFlowButton flowId={flow?.id} />
        </Box>
        <Box xcss={boxStyle}>
          <RestoreFlow />
        </Box>
      </Stack>
    </>
  );
};

export default BackupPage;
